module.exports = __webpack_public_path__ + "assets1783936157458/img/error-401.98bba5b1.svg";